import { useState } from "react";
import { Paperclip, Mic, ImageIcon, Send, Sparkles } from "lucide-react";

export default function AgentPanel() {
  const [ojkStrict, setOjkStrict] = useState(true);
  const [input, setInput] = useState("");

  return (
    <aside className="w-[350px] flex-shrink-0 h-screen bg-white border-l border-gray-100 flex flex-col">
      {/* Header */}
      <div className="px-5 py-4 border-b border-gray-100 flex items-start justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-indigo-600 flex items-center justify-center">
            <Sparkles size={14} className="text-white" />
          </div>
          <div>
            <p className="text-sm font-bold text-gray-900">Nexus AI</p>
            <div className="flex items-center gap-1.5 mt-0.5">
              <span className="w-1.5 h-1.5 rounded-full bg-green-400" />
              <span className="text-[10px] text-gray-400 tracking-wide">ACTIVE INTELLIGENCE</span>
            </div>
          </div>
        </div>
        {/* OJK Strict toggle */}
        <div className="flex flex-col items-end gap-1">
          <span className="text-[10px] font-bold text-gray-500 tracking-widest">OJKSTRICT</span>
          <button
            onClick={() => setOjkStrict(!ojkStrict)}
            className={`relative w-11 h-6 rounded-full transition-colors ${
              ojkStrict ? "bg-indigo-600" : "bg-gray-200"
            }`}
          >
            <span
              className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-all ${
                ojkStrict ? "left-6" : "left-1"
              }`}
            />
          </button>
        </div>
      </div>

      {/* Chat messages area */}
      <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">
        {/* Placeholder message bubbles — real data connected in next step */}
        <div className="flex justify-end">
          <div className="bg-indigo-600 text-white text-xs rounded-2xl rounded-tr-sm px-4 py-3 max-w-[80%] leading-relaxed">
            Analyze market gap for &quot;Kredit Cepat&quot; and &quot;Bunga 0%&quot; relative to OJK financial safety regulations.
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-[10px] font-bold text-indigo-600 tracking-widest flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-sm bg-indigo-600 inline-block" />
            COMPLIANCE ANALYSIS
          </p>
          <div className="bg-gray-50 rounded-2xl rounded-tl-sm px-4 py-3 text-xs text-gray-700 leading-relaxed border border-gray-100">
            <p>
              I&apos;ve cross-referenced these terms with current 2024 OJK guidelines.
              &quot;Bunga 0%&quot; is flagged as{" "}
              <span className="text-red-500 font-bold">High Risk</span> for marketing
              unless backed by explicit collateral disclosures.
            </p>
            <div className="mt-3 border-l-2 border-indigo-300 pl-3 space-y-2">
              <div>
                <p className="text-[10px] font-bold text-gray-400 tracking-widest">RECOMMENDATION</p>
                <p className="text-xs text-gray-600 mt-0.5">
                  Pivot to: &quot;Kredit Transparan &amp; Berizin OJK&quot;
                </p>
              </div>
              <div>
                <p className="text-[10px] font-bold text-gray-400 tracking-widest">OPPORTUNITY SCORE</p>
                <p className="text-2xl font-bold text-gray-900 mt-0.5">
                  84 <span className="text-sm font-normal text-gray-400">/100</span>
                </p>
              </div>
            </div>
          </div>
          <p className="text-[10px] text-gray-400 px-1">NEXUS · 14:03</p>
        </div>

        {/* Typing indicator placeholder */}
        <div className="flex gap-1 px-1">
          <span className="w-2 h-2 rounded-full bg-gray-300 animate-bounce" style={{ animationDelay: "0ms" }} />
          <span className="w-2 h-2 rounded-full bg-gray-300 animate-bounce" style={{ animationDelay: "150ms" }} />
          <span className="w-2 h-2 rounded-full bg-gray-300 animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
      </div>

      {/* Input bar */}
      <div className="px-4 py-4 border-t border-gray-100">
        <div className="flex items-center gap-2 bg-gray-50 rounded-2xl px-4 py-2.5 border border-gray-200 focus-within:border-indigo-300 focus-within:ring-1 focus-within:ring-indigo-100 transition-all">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ask Nexus to write content..."
            className="flex-1 bg-transparent text-sm text-gray-700 placeholder-gray-400 focus:outline-none"
          />
        </div>
        <div className="flex items-center justify-between mt-3 px-1">
          <div className="flex items-center gap-3">
            <button className="text-gray-400 hover:text-gray-600 transition-colors">
              <Paperclip size={15} />
            </button>
            <button className="text-gray-400 hover:text-gray-600 transition-colors">
              <Mic size={15} />
            </button>
            <button className="text-gray-400 hover:text-gray-600 transition-colors">
              <ImageIcon size={15} />
            </button>
          </div>
          <button
            className={`w-8 h-8 rounded-xl flex items-center justify-center transition-colors ${
              input.trim()
                ? "bg-indigo-600 hover:bg-indigo-700 text-white"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
          >
            <Send size={13} />
          </button>
        </div>
      </div>
    </aside>
  );
}
